import colors from './colors'

/**
 * Shared Outlined card shape. Shadow and tone come from the theme.
 * See `legacyCardLayerStyles` for flag-OFF.
 */
const cardSurface = {
  bg: 'var(--cnvs-sys-color-bg-default)',
  border: '1px solid var(--cnvs-sys-color-border-strong)',
  borderRadius: 'xxl'
}

/**
 * Default (rebrand) layerStyles. Flag-OFF theme merges `legacyCardLayerStyles` over these.
 */
const layerStyles = {
  /** Card surface for the Card theme and `layerStyle="card"`. Flat on rebrand. */
  card: {
    ...cardSurface,
    boxShadow: 'none'
  },
  /** Tonal card: same radius, toned bg, no border on rebrand. Filter sidebar, action bar. */
  cardTonal: {
    bg: 'var(--cnvs-sys-color-bg-alt-default)',
    border: 'none',
    borderRadius: 'xxl',
    boxShadow: 'none'
  },
  light: {
    color: 'var(--vndly-color-container-light)',
    bg: 'var(--vndly-color-container-background-dark)'
  },
  dark: {
    color: 'var(--vndly-color-container-dark)'
  },
  // @deprecated: Moved inlineGray and inlineDark to Link global vairants instead.
  inlineGray: {
    color: 'var(--vndly-color-container-subdued) !important'
  },
  // @deprecated: Moved inlineGray and inlineDark to Link global vairants instead.
  inlineDark: {
    color: 'var(--vndly-color-container-dark) !important'
  },
  successGradient: {
    bgGradient: 'linear(to-r, var(--vndly-color-feedback-background-success), var(--vndly-color-feedback-success))'
  },
  warningGradient: {
    bgGradient: 'linear(to-r, yellow.100, yellow.500)'
  },
  dangerGradient: {
    bgGradient: 'linear(to-r, red.100, red.500)'
  },
  completeGradient: {
    bgGradient: 'linear(to-r, gray.400, gray.600)'
  },
  incompleteGradient: {
    bgGradient: 'linear(to-r, gray.200, gray.300)'
  },
  infoGradient: {
    bgGradient: 'linear(to-r, blue.100, blue.500)'
  },
  brandGradient: {
    bgGradient: 'linear(to-r, var(--vndly-color-feedback-success), blue.500)'
  }
}

/**
 * Flag-OFF overrides for `card` / `cardTonal`. Merged into
 * `workdayThemeLegacyVisualTokens.layerStyles`.
 */
export const legacyCardLayerStyles = {
  card: {
    ...cardSurface,
    boxShadow: 'base'
  },
  cardTonal: {
    bg: colors.gray[50],
    border: `1px solid ${colors.gray[300]}`,
    borderRadius: 'xxl',
    boxShadow: 'none'
  }
}

export { layerStyles }
